import CheckboxControl from './fields/CheckboxControl';
import ColorPicker from './fields/ColorPicker';
import DatePicker from './fields/DatePicker';
import FieldOptions from './fields/FieldOptions';
import GalleryPicker from './fields/GalleryPicker';
import ImagePicker from './fields/ImagePicker';
import LinkButton from './fields/LinkButton';
import MultiSelectControl from './fields/MultiSelectControl';
import RangeSliderControl from './fields/RangeSliderControl';
import RadioControl from './fields/RadioControl';
import RepeaterControl from './fields/RepeaterControl';
import SelectControl from './fields/SelectControl';
import TextControl from './fields/TextControl';
import TextareaControl from './fields/TextareaControl';
import ToggleControl from './fields/ToggleControl';

export const fieldComponents = {
    checkbox: CheckboxControl,
    color: ColorPicker,
    date: DatePicker,
    email: TextControl,
    gallery: GalleryPicker,
    image: ImagePicker,
    link_button: LinkButton,
    multi_select: MultiSelectControl,
    number: TextControl,
    options: FieldOptions,
    password: TextControl,
    radio: RadioControl,
    select: SelectControl,
    text: TextControl,
    textarea: TextareaControl,
    toggle: ToggleControl,
    url: TextControl,
    range_slider: RangeSliderControl,
    repeater: RepeaterControl,
};

export {
    CheckboxControl,
    ColorPicker,
    DatePicker,
    FieldOptions,
    GalleryPicker,
    ImagePicker,
    LinkButton,
    MultiSelectControl,
    RadioControl,
    RepeaterControl,
    SelectControl,
    TextControl,
    TextareaControl,
    ToggleControl,
};

export const defaultValues = {
    checkbox: false,
    color: '',
    date: '',
    fieldOptions : [],
    email: '',
    gallery: [],
    image: [],
    link_button: { text: '', url: '' },
    multi_select: [],
    number: '',
    password: '',
    radio: '',
    repeater: [],
    select: '',
    text: '',
    textarea: '',
    toggle: false,
    url: '',
};
